import { createSelector } from 'reselect';
import { getSelectedCell } from '../ui';

export function getGenerations(state) {
  return state.generations.generations;
}

export const getSelectedGeneration = createSelector(
  getGenerations,
  getSelectedCell,
  (generations, cell) => (
    generations[cell.generation]
  )
)


// WEBPACK FOOTER //
// ./src/core/generations/selectors.js